module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "banner-container"
  }, [_c('img', {
    staticClass: "banner",
    attrs: {
      "src": _vm.image
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "logo-container"
  }, [_c('router-link', {
    attrs: {
      "to": "/home"
    }
  }, [_c('img', {
    staticClass: "logo",
    attrs: {
      "src": _vm.logo
    }
  })])], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-938d1614"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/sections/MainBanner.vue
// module id = 442
// module chunks = 0